import { useAppSettings } from './use-app-settings';
import { useSudokuGame } from './use-sudoku-game';
import { AppShell } from '../ui/shell/AppShell';

export function App() {
  const settings = useAppSettings();
  const game = useSudokuGame();

  return (
    <AppShell
      language={settings.language}
      theme={settings.resolvedTheme}
      onLanguageChange={settings.setLanguage}
      onThemeChange={settings.setTheme}
      game={game.model}
      elapsedMs={game.nowMs}
      onGameAction={game.dispatch}
      onNewGame={game.newGame}
    />
  );
}
